module.exports = __webpack_public_path__ + "media/images/university_logos/Queens-University-Belfast-f870e3d1b25529c83026e1e197f96de7.svg";